import React from "react";

import './components/App.css';
import Chatbot from "./components/Chatbot";

export default function App() {

  return (
  <>
  <div className="main_heading">Mitram.ai</div>
  <Chatbot/>
  </>   
  );
}

